import React, { useState, useEffect } from 'react'
import PropTypes from 'prop-types'
import FormSection from "components/sales/formSection/formSection"
import Regex from "services/utils/regex/Regex";
import localization from "assets/localization/localization";
import ConstantInput from "components/sales/Input/constantInput/constantInput";
import { handleValidateObj } from "constants/objValues/objvalues";

const Contact = ({
    title,
    name,
    phone,
    handleValue,
    poc
}) => {
    const inputData = {
        name: "",
        contact: ""
    }
    const [formData, setData] = useState(inputData);

    const handleData = () => {
        if (handleValue) {
            if (formData.name !== '' || formData.contact !== '') {
                if (poc === "true") {
                    handleValue({
                        poc: [{ ...formData }]
                    });
                } else {
                    handleValue({
                        escalation_contact: [{ ...formData }]
                    });
                }
            } else {
                handleValue(null)
            }
        }
    }

    useEffect(() => {
        handleData();
    }, [formData]);
    return (
        <FormSection title={title}>
            <ConstantInput
                label={name}
                errorMsg={localization.nameError}
                inputValue={formData.name}
                type='text'
                handleChange={value => setData({ ...formData, name: value })}
                className={formData.name.length ? '' : 'empty'}
                regex={Regex.text.test(formData.name)}
            />
            <ConstantInput
                label={phone}
                errorMsg={localization.phoneError}
                inputValue={formData.contact}
                type="text"
                minLength="10"
                maxLength="10"
                handleChange={value => setData({ ...formData, contact: value })}
                className={formData.contact.length ? '' : 'empty'}
                regex={Regex.phoneNumber.test(formData.contact)}
            />
        </FormSection>
    )
}

Contact.propTypes = {

}

export default Contact
